"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardGrouppingDataProvider = void 0;
const constants_1 = require("../utils/constants");
class CardGrouppingDataProvider {
    #cards = [];
    #productApiResponse;
    #limit;
    #summaryBuilder;
    #requestUrl;
    constructor(requestUrl, limit = 60, summaryBuilder) {
        this.#requestUrl = requestUrl;
        this.#limit = limit;
        this.#summaryBuilder = summaryBuilder;
    }
    getAlternativeProducts(originalUrl) {
        throw new Error("Method should not be called");
    }
    getCardData(index) {
        return this.#productApiResponse?.card_recommendations[index];
    }
    addOriginalUrl(url, card, maxLinksPerCard) {
        let cardIndex = card.index;
        for (let i = this.#cards.length; i <= cardIndex; i++) {
            this.#cards[i] = {
                max_number_of_alternatives: maxLinksPerCard || 3,
                //should work on this above line
                urls: []
            };
        }
        this.#cards[cardIndex].urls.push(url);
    }
    async execute(impressionId) {
        if (this.#cards.length > this.#limit) {
            this.#cards.splice(this.#limit);
        }
        let referrerURL = window.location.href;
        const payload = {
            impression_id: impressionId,
            referrer_url: referrerURL,
            cards: this.#cards,
        };
        let response;
        let start = Date.now();
        try {
            response = await fetch(this.#requestUrl, {
                ...constants_1.POST_FETCH_CONFIG,
                body: JSON.stringify(payload),
            });
            this.#summaryBuilder.setApiResponseTimeMs(Date.now() - start);
            this.#summaryBuilder.setApiResponseCode(response.status);
            if (!response.ok) {
                this.#summaryBuilder.setApiResponseMessage(response.statusText);
            }
            this.#productApiResponse = (await response.json());
        }
        catch (error) {
            this.#summaryBuilder.setApiResponseTimeMs(response ? Date.now() - start : 0);
            this.#summaryBuilder.setApiResponseCode(response?.status);
            this.#summaryBuilder.setApiResponseMessage("Links and buttons - CardGrouppingDataProvider - Problem while fetching alternatives: " +
                error?.toString() +
                " " +
                response?.statusText);
        }
    }
}
exports.CardGrouppingDataProvider = CardGrouppingDataProvider;
